module.exports = __webpack_public_path__ + "img/channel_people_icon.0048a025.png";